export default __webpack_public_path__ + "static/media/GreenyBits.7603f57a.jpg";